<template>
  <div class="mk-subject-header-top">
    <span v-if="childItem.propsValue.data.customField1" class="mk-subject-header-top-info-phone">
      <img src="https://mks.yybip.com/group1/M00/09/2F/CgoRC2O7t-qAT6-YAAABrXqugto633.png" alt />
      <span>{{ childItem.propsValue.data.customField1 }}</span>
    </span>
    <span v-if="childItem.propsValue.data.customField2" class="mk-subject-header-top-info-phone">
      <img src="https://mks.yybip.com/group1/M00/09/2F/CgoRC2O7t-qAT6-YAAABrXqugto633.png" alt />
      <span>{{ childItem.propsValue.data.customField2 }}</span>
    </span>
    <a v-if="childItem.propsValue.data.customField3">
      <span class="mk-subject-header-top-info-email">
        <img src="https://mks.yybip.com/group1/M00/09/2F/CgoRC2O7uAiAG7hwAAABaHRK4PU617.png" alt />
        <span>{{ childItem.propsValue.data.customField3 }}</span>
      </span>
    </a>
  </div>
</template>

<script>
export default {
  name: "MkHeaderTopWeb",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "电话1",
          type: "text"
        },
        {
          code: "customField2",
          label: "电话2",
          type: "text"
        },
        {
          code: "customField3",
          label: "邮箱",
          type: "text"
        }
      ],
      data: {
        customField1: "",
        customField2: "",
        customField3: ""
      }
    };
  }
};
</script>


<style lang="scss" scoped>
.mk-subject-header-top {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #000000;
  width: 100%;
  margin: 0 auto;
  text-align: right;
  font-size: 12px;
  color: #fff;
  line-height: 30px;
  padding: 0 30px;
  span {
    font-size: 12px;
  }
  > span {
    display: inline-block;
    padding: 0 10px;
    img {
      height: 12px;
    }
  }
  > a {
    color: #fff;
    img {
      height: 12px;
    }
  }
}
</style>
